import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Seo from '../components/ui/Seo';
import BlurFade from '../components/ui/BlurFade';
import { posts } from '../data/blog';

const formatDate = (iso) =>
  new Date(iso).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });

const BlogList = () => {
  return (
    <main className="bg-white pb-20 pt-32 text-black">
      <Seo
        title="Blog | Prathamesh Shete"
        description="Notes on AI engineering, RAG pipelines, and building production AI systems."
        path="/blog"
      />

      <div className="mx-auto max-w-4xl px-6">
        <BlurFade>
          <h1 className="mb-3 text-3xl font-black sm:text-4xl">
            Blog<span className="text-black/30">.</span>
          </h1>
        </BlurFade>
        <BlurFade delay={0.05}>
          <p className="mb-10 text-black/60">Notes on AI engineering, RAG pipelines, and building production AI systems.</p>
        </BlurFade>

        <div className="grid grid-cols-1 items-stretch gap-5 sm:grid-cols-2">
          {posts.map((post, i) => (
            <BlurFade key={post.slug} delay={(i % 6) * 0.05} className="h-full">
              <motion.div whileHover={{ y: -6, boxShadow: '0 10px 0 0 rgba(0,0,0,1)' }} className="h-full">
                <Link
                  to={`/blog/${post.slug}`}
                  className="flex h-full flex-col rounded-xl border-2 border-black bg-white p-5"
                >
                  <span className="text-xs font-semibold text-black/40">{formatDate(post.date)}</span>
                  <h2 className="mt-2 line-clamp-2 min-h-[3.5rem] text-lg font-black leading-tight">{post.title}</h2>
                  <p className="mt-2 line-clamp-3 min-h-[4rem] flex-1 text-sm text-black/60">{post.excerpt}</p>
                  <div className="mt-4 flex flex-wrap gap-1.5">
                    {post.tags.map((tag) => (
                      <span key={tag} className="rounded-full border border-black/20 px-2 py-0.5 text-xs text-black/60">
                        {tag}
                      </span>
                    ))}
                  </div>
                </Link>
              </motion.div>
            </BlurFade>
          ))}
        </div>
      </div>
    </main>
  );
};

export default BlogList;
